import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Header } from '../components/Header';
import { toast } from 'react-toastify';
import { API_BASE, apiFetch } from '../lib/api';
import { useAuth } from '../context/AuthContext';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

const Footer = () => (
    <></>
    // <footer className="bg-gray-800 text-white p-4 text-center mt-auto">
    //     <p>Contact Us: vikas@filtron.co.in</p>
    //     <p>Berger Paints, India</p>
    // </footer>
);

export default function Home() {
    const [loginCode, setLoginCode] = useState('');
    const [showCode, setShowCode] = useState(false);
    const navigate = useNavigate();
    const { status, user, refreshAuth } = useAuth();

    useEffect(() => {
        if (status !== 'loading' && user) {
            navigate('/scheme-chat', { replace: true });
        }
    }, [navigate, status, user]);

    const handleStart = async () => {
        if (loginCode.trim()) {
            try {
                const res = await apiFetch(`${API_BASE}/api/auth/login`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ code: loginCode.trim() }),
                });

                if (!res.ok) {
                    const data = await res.json().catch(() => ({}));
                    toast.error(data?.message ?? 'Invalid login code');
                    return;
                }

                await refreshAuth();
                navigate('/scheme-chat', { replace: true });
            } catch {
                toast.error('Unable to login right now');
            }
        }
    };

    const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter') {
            handleStart();
        }
    };

    return (
        <div
            className="flex flex-col min-h-screen"
            style={{
                backgroundImage: `url(/images/landing_bgclear.png)`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                backgroundAttachment: 'fixed',
            }}
        >
            <Header />
            <main className="flex flex-col items-center justify-top flex-grow">
                <div className="flex justify-center pt-24 pb-8">
                    <img src="/images/logo_256.png" className="h-32" />
                </div>
                <div className="p-8 bg-white rounded-lg shadow-md w-full max-w-md">
                    <h1 className="text-3xl font-bold text-center text-gray-800 mb-6">
                        Access Berger AI
                    </h1>
                    <form
                        className="mb-4"
                        onSubmit={(e) => {
                            e.preventDefault();
                            handleStart();
                        }}
                    >
                        <input
                            type="text"
                            name="username"
                            autoComplete="username"
                            value="berger"
                            readOnly
                            className="sr-only"
                            tabIndex={-1}
                        />
                        {/* <label htmlFor="login_code" className="block text-sm font-medium text-gray-700 mb-1">
                            Access Berger Agent
                        </label> */}

                        <div className="relative">
                            <input
                                id="login_code"
                                name="password"
                                type={showCode ? 'text' : 'password'}
                                value={loginCode}
                                onChange={(e) => setLoginCode(e.target.value)}
                                onKeyDown={handleKeyPress}
                                className="w-full border rounded p-2 pr-10"
                                placeholder="Please enter security code"
                                autoComplete="current-password"
                            />
                            <button
                                type="button"
                                onClick={() => setShowCode((v) => !v)}
                                className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700"
                                aria-label={showCode ? 'Hide security code' : 'Show security code'}
                            >
                                {showCode ? <FaEyeSlash /> : <FaEye />}
                            </button>
                        </div>
                    </form>
                    <button
                        onClick={handleStart}
                        disabled={!loginCode.trim()}
                        className="w-full bg-blue-600 text-white py-2 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:bg-blue-300"
                    >
                        Start
                    </button>
                </div>
            </main>
            <Footer />
        </div>
    );
}
